var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "마이인재풀 관리"
    }
  }, [_c('template', {
    slot: "contents"
  }, [_c('v-tabs', {
    staticClass: "v-tabs--underline mb-20 mb-lg-40"
  }, _vm._l(_vm.tabs, function (_ref) {
    var value = _ref.value,
      text = _ref.text;
    return _c('v-tab', {
      key: value,
      attrs: {
        "to": `/dashboard/human-resource/${value}`
      }
    }, [_vm._v(_vm._s(text))]);
  }), 1), _c('v-tabs-items', {
    staticClass: "fill-height",
    attrs: {
      "value": _vm.tab
    }
  }, [_c('human-resource-recruits', {
    attrs: {
      "tab": _vm.TABS.RECRUITS.value,
      "title": _vm.TABS.RECRUITS.text
    }
  }), _c('human-resource-applicants', {
    attrs: {
      "tab": _vm.TABS.APPLICANTS.value,
      "title": _vm.TABS.APPLICANTS.text
    }
  }), _c('human-resource-favorites', {
    attrs: {
      "tab": _vm.TABS.FAVORITES.value,
      "title": _vm.TABS.FAVORITES.text
    }
  }), _c('human-resource-blacklist', {
    attrs: {
      "tab": _vm.TABS.BLACKLIST.value,
      "title": _vm.TABS.BLACKLIST.text
    }
  }), _c('human-resource-qualifiers', {
    attrs: {
      "tab": _vm.TABS.QUALIFIERS.value,
      "title": _vm.TABS.QUALIFIERS.text
    }
  })], 1)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }